import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@shared/components/ui/shadcn/dialog';
import { useTranslation } from 'react-i18next';
import type { ProfitabilitySummaryBreakdownQuery } from '../../models/Profitability';
import { ProfitabilitySummaryShippingCostsTable } from '../display/ProfitabilitySummaryShippingCostsTable';

interface ProfitabilitySummaryShippingCostsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  filters?: ProfitabilitySummaryBreakdownQuery;
  locale: string;
}

export const ProfitabilitySummaryShippingCostsModal = ({
  open,
  onOpenChange,
  filters,
  locale,
}: ProfitabilitySummaryShippingCostsModalProps) => {
  const { t } = useTranslation('profitabilityModule');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-h-[90vh] max-w-[min(96vw,80rem)] overflow-y-auto border-border bg-background"
        data-testid="profitability-summary-shipping-costs-modal"
      >
        <DialogHeader>
          <DialogTitle>{t('summary.shipping_costs_breakdown.title')}</DialogTitle>
        </DialogHeader>

        <p className="text-sm text-muted-foreground">{t('summary.shipping_costs_breakdown.hint')}</p>

        {open && <ProfitabilitySummaryShippingCostsTable filters={filters} locale={locale} embedded enabled={open} />}
      </DialogContent>
    </Dialog>
  );
};
